export { default as MaterialsClientFilter } from './MaterialsClientFilter';
